export const FILE_MAX_SIZE = 20 << (10 * 2); // 20MB
export const FILE_SIZE_LABEL = "Max File size: 20 MB";
export const FILE_SIZE_ERR_MSG = "Max file size is 20MB.";
export const FILE_ACCEPTED_TYPES = [
  "application/pdf",
  "application/json",
  "image/png",
  "image/jpeg",
  "image/webp",
];
export const FILE_TYPE_ERR_MSG = `${FILE_ACCEPTED_TYPES.map((type) =>
  type.substring(type.indexOf("/") + 1),
).join(", ")} files are accepted.`;
